<template>
  <div class="contact-form-container">
    <h1>{{ $t("areYouReadyTogetStarted?") }}</h1>
    <div v-if="open" class="success-msg" style="margin-top: 10px;">
      <p>{{ $t("thanks!!") }}</p>
    </div>
    <form @submit.prevent="handleSubmitForm">
      <textarea
        type="text"
        name="userMessage"
        :placeholder="$t('writeYourMessage')"
        v-model="message"
        rows="4"
        cols="50"
        required
      ></textarea>
      <div class="form-input-con">
        <input
          type="email"
          :placeholder="$t('email')"
          v-model="email"
          required
        />
        <input
          type="text"
          :placeholder="$t('yourname')"
          v-model="username"
          required
        />
      </div>
      <button type="submit">{{ $t("send") }}</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      open: false,
      message: "",
      email: "",
      username: ""
    };
  },
  methods: {
    showMessage() {
      this.open = true;
      this.message = "";
      this.email = "";
      this.username = "";
      setTimeout(() => {
        this.open = false;
      }, 6000);
    },
    handleSubmitForm() {
      let data = {
        username: this.username,
        email: this.email,
        message: this.message
      };
      console.log(data);
      this.showMessage();
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-form-container {
  padding: 100px 0px;
  text-align: center;
  width: 65%;
  margin: 0 auto;
}
.contact-form-container h1 {
  color: #cedb2d;
}
.success-msg {
  color: #cedb2d;
}
form {
  margin-top: 50px;
}

textarea,
input,
button,
label {
  padding: 12px 14px;
}

textarea,
button,
input:focus {
  outline: thin;
}

::placeholder {
  color: white;
  opacity: 1; /* Firefox */
}

textarea {
  width: 100%;
  resize: none;
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
}

input {
  width: 49.255%;
  margin: 10px 0px;
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
}

button {
  margin: 10px 0px;
  width: 100%;
  color: #1d1d1d;
  font-weight: bold;
  background-color: #cedb2d;
}

.form-input-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .contact-form-container {
    width: 75%;
  }
  .form-input-con {
    flex-wrap: wrap;
  }
  input {
    width: 100%;
  }
}
@media (max-width: 625px) {
  .contact-form-container {
    width: 85%;
  }
}
</style>
